import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
            flexDirection: 'column',
            height: '100%',
            padding: 0,
        },
        overflowY: 'auto',
        padding: theme.spacing(2),
        paddingTop: theme.spacing(4),
        '&::-webkit-scrollbar': {
            width: '18px',
        },
        '&::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.3)',
            borderRadius: '20px',
            border: '6px solid transparent',
            backgroundClip: 'content-box',
            '&:hover': {
                backgroundColor: 'rgba(0,0,0,.15)',
            },
        },
    },
    disabled: {
        cursor: 'not-allowed',
        opacity: 0.5
    },
    imgContainer: {
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        maxWidth: '400px',
        maxHeight: '400px',
        minWidth: '400px',
        minHeight: '400px',
        marginRight: '2rem',
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            maxHeight: '100%',
            minWidth: '100%',
            minHeight: '300px',
            borderRadius: 0,
            marginRight: 'unset',
        },
    },
    title: {
        fontWeight: 600,
        lineHeight: 1.2,
        [theme.breakpoints.up('sm')]: {
            marginRight: theme.spacing(5),
        }
    },
    closeIcon: {
        fill: theme.palette.text.primary,
        margin: 0,
        width: '28px',
        height: '28px',
    },
    closeButton: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        minWidth: '50px',
        minHeight: '50px',
        maxWidth: '50px',
        maxHeight: '50px',
        zIndex: 999,
        [theme.breakpoints.down('sm')]: {
            left: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
            '&:hover': {
                backgroundColor: theme.palette.background.paper,
            },
        },
        padding: 0
    },
    container: {
        height: '100%',
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },
    info: {
        marginRight: 'unset',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            boxShadow: theme.shadows[4],
            marginLeft: 'unset',
            marginRight: 'auto',
            flex: 1,
            padding: theme.spacing(2),
            marginTop: theme.spacing(-3),
            backgroundColor: theme.palette.background.paper,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
        },
    },
    footerContainer: {
        marginTop: 'auto',
    },

    btnConfirmar: {
        [theme.breakpoints.down('sm')]: { flex: '1 1 60%' },

        marginLeft: '.8rem',
    },
    iconBasket: {
        marginRight: '.5rem',
    },
    seletor: {
        width: '100px',
        display: 'flex',
        position: 'relative',
        justifyContent: 'space-between',
        border: '1px solid #9A9A9A',
        alignItems: 'center',
        padding: '10px',
        borderRadius: theme.shape.borderRadius,
        [theme.breakpoints.down('sm')]: { flex: '1 1 30%' },
    },
    selectorValue: {
        textAlign: 'center',
    },
    adicionar: {
        color: theme.palette.text.primary,
    },
    remover: {
        color: theme.palette.text.primary
    },
    btn: {
        cursor: 'pointer',
    },

    btnsConfirmar: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',

        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: { justifyContent: 'center' },
    },
    observacao: {
        marginTop: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            marginTop: '1rem',
        },
    },
}));